import axios from 'axios';

export const freeAxiosInstance = axios.create({});
